// Declare uc as a global variable
declare const uc: any

import { useEffect, useState } from 'react'

export const useGetCookieConsentAccepted = ({
  consentId,
}: {
  consentId: string
}) => {
  // null = unknown yet
  const [accepted, setAccepted] = useState<boolean | null>(null)

  // we want this hook to run every time when the component rerenders
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // Check if uc is defined and has the ucapi property, external script could be blocked by adblockers.
    if (typeof uc === 'undefined' || typeof uc?.ucapi === 'undefined') {
      return
    }
    const acceptedConsentIds = uc.ucapi.getWhitelistedServices()
    setAccepted(acceptedConsentIds.includes(consentId))
  })

  return accepted
}
